import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import LinkButtons from "./LinkButtons";

const MainLinkButton = () => {
	const personalLinks = [{ title: "Explore XData!", link: "https://xdata.uz" }];
	const myCareer = [
		{
			title: "Explore My Career!",
			link: "https://linktr.ee/ibrohimbek_career",
		},
	];
	const ilmoraEdu = [
		{
			title: "Expore ilmora Edu",
			link: "https://linktr.ee/ilmora_edu",
		},
	];

	const seeMyPortfolio = [
		{
			title: "View Portfolio!",
			link: "https://linktr.ee/ilmora",
		},
	];

	const aboutCEO = [
		{ title: "About CEO!", link: "https://ilmora-edu.org/about-ceo" },
	];

	const donateWith = [
		{ title: "Donate with PayPal!", link: "soon" },
		{ title: "Donate with Stripe!", link: "soon" },
	];

	return (
		<AnimatePresence>
			<motion.div
				initial={{ opacity: 0, y: -50 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
				className="space-y-2 p-0 sm:pb-4 w-full h-auto flex flex-col justify-center items-center"
			>
				<LinkButtons dataLinks={personalLinks} btnName={"Explore XData"} />
				<LinkButtons dataLinks={myCareer} btnName={"My Career"} />
				<LinkButtons dataLinks={ilmoraEdu} btnName={"Learn English"} />
				<LinkButtons dataLinks={seeMyPortfolio} btnName={"View Portfolio"} />
				<LinkButtons dataLinks={aboutCEO} btnName={"About CEO"} />
				<LinkButtons dataLinks={donateWith} btnName={"Support the Project"} />
			</motion.div>
		</AnimatePresence>
	);
};

export default MainLinkButton;
